import __request__ from 'routing/request';
interface Binding {
    readonly type: string;
}
interface TimeRange {
    readonly type: string;
}
interface ValidationMessageDTO {
    readonly error_title: string;
    readonly error_message: string;
    readonly related_property: string;
    readonly begin_column: number;
    readonly error_type: 'UNDECLARED_PARAMETER' | 'EMPTY_PARAMETER' | 'QUERY_PARSING_ERROR' | 'UNKNOWN_FIELD' | 'INVALID_OPERATOR' | 'MISSING_LICENSE' | 'INVALID_VALUE_TYPE' | 'PARAMETER_NOT_ALLOWED';
    readonly begin_line: number;
    readonly end_line: number;
    readonly end_column: number;
}
interface ValidationResponseDTO {
    readonly explanations: ValidationMessageDTO[];
    readonly status: 'OK' | 'WARNING' | 'ERROR';
}
interface Parameter {
    readonly name: string;
    readonly data_type: string;
    readonly binding: Binding;
    readonly description: string;
    readonly optional: boolean;
    readonly default_value: Object;
    readonly title: string;
    readonly type: string;
}
interface Object {
}
interface ValidationRequestDTO {
    readonly parameter_bindings: {
        readonly [_key: string]: Binding;
    };
    readonly filter: BackendQuery;
    readonly timerange: TimeRange;
    readonly validation_mode: 'QUERY' | 'SEARCH_FILTER';
    readonly query: BackendQuery;
    readonly streams: string[];
    readonly parameters: Parameter[];
}
interface BackendQuery {
}
/**
 * Validate a search query
 */
export function validateQuery(validationRequest?: ValidationRequestDTO): Promise<ValidationResponseDTO> {
    return __request__('POST', '/search/validate', validationRequest, {}, {
        'Accept': ['application/json']
    });
}
